import React, { useEffect, useState } from 'react';
import { postAcknowledgment, getAcknowledgment } from '../../services/speakerCorrectionAcknowledgments';

interface Props {
  encounterId: string;
  autoCorrectCount: number;
  onReview: () => void;
}

export function AutoCorrectBanner({ encounterId, autoCorrectCount, onReview }: Props) {
  const [acknowledged, setAcknowledged] = useState<boolean | null>(null);
  const [reviewed, setReviewed] = useState(false);

  useEffect(() => {
    if (autoCorrectCount > 0) {
      getAcknowledgment(encounterId)
        .then((r) => setAcknowledged(r.acknowledged))
        .catch(() => setAcknowledged(false));
    }
  }, [encounterId, autoCorrectCount]);

  if (autoCorrectCount === 0) return null;
  if (acknowledged === true) return null;

  function handleReview() {
    setReviewed(true);
    onReview();
  }

  async function handleDismiss() {
    if (!reviewed) return;
    try {
      await postAcknowledgment(encounterId);
      setAcknowledged(true);
    } catch (_) {
      // Silently fail; banner stays.
    }
  }

  return (
    <div
      role="status"
      aria-label="System auto-corrected speakers"
      className="mb-4 p-3 bg-slate-50 border-l-4 border-slate-500 flex items-center justify-between"
    >
      <span className="text-sm">
        &#9881; System auto-corrected <strong>{autoCorrectCount}</strong> speaker {autoCorrectCount === 1 ? 'assignment' : 'assignments'} on this encounter.
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={handleReview}
          className="text-sm px-3 py-1 border rounded bg-white hover:bg-slate-100"
        >
          Review changes
        </button>
        <button
          type="button"
          onClick={handleDismiss}
          disabled={!reviewed}
          className="text-sm px-3 py-1 border rounded bg-white disabled:opacity-50"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
